import React from 'react';
import { InitialErrorMessage } from './InitialErrorMessage';

interface InitialErrorBoundaryProps {
    children: React.ReactNode;
}

interface InitialErrorBoundaryState {
    hasError: boolean;
    notRender: boolean;
}

/**
 * Error boundary for the initial render of the application.
 */
export class InitialErrorBoundary extends React.Component<InitialErrorBoundaryProps, InitialErrorBoundaryState> {
    /**
     * @param props - children components
     */
    constructor(props: InitialErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, notRender: false };

        this.setNotRender = this.setNotRender.bind(this);
    }

    static getDerivedStateFromError(error: unknown) {
        return { hasError: true };
    }

    /**
     * Lifecycle method that is invoked after an error has been thrown by a descendant component.
     * @param error
     * @param errorInfo
     */
    override componentDidCatch(error: unknown, errorInfo: React.ErrorInfo) {
        console.error('InitialErrorBoundary', error, errorInfo);
    }

    /**
     * Disables rendering of the error message.
     */
    public setNotRender = () => {
        this.setState({ notRender: true });
    };

    override render() {
        if (this.state.hasError) {
            if (this.state.notRender) {
                return null;
            }
            return <InitialErrorMessage setNotRender={this.setNotRender} />;
        }

        return this.props.children;
    }
}
